import { nameOf } from '../../../app/shared/common';
import { QueryParser } from '../../../app/shared/QueryParser';

export class ProductListingQuery {
  phrase?: string;
  brands?: string[] = [];
  priceMin?: number;
  priceMax?: number;
  sectors?: string[] = [];
  types?: string[] = [];
  sort?: string;
  direction?: string;
  expanded?: string[] = [];
}

export const PHRASE = nameOf<ProductListingQuery>('phrase');
export const BRANDS = nameOf<ProductListingQuery>('brands');
export const PRICE_MIN = nameOf<ProductListingQuery>('priceMin');
export const PRICE_MAX = nameOf<ProductListingQuery>('priceMax');
export const SECTORS = nameOf<ProductListingQuery>('sectors');
export const TYPES = nameOf<ProductListingQuery>('types');
export const SORT = nameOf<ProductListingQuery>('sort');
export const DIRECTION = nameOf<ProductListingQuery>('direction');
export const EXPANDED = nameOf<ProductListingQuery>('expanded');

/** `direction` is left out for the ascending default. */
export const DESCENDING = 'desc';

/** Expanding every family is a mode that outlives the families it holds, so it is not a list of ids. */
export const EXPANDED_ALL = 'all';

export class ProductListingQueryParser extends QueryParser {
  public static toModel(query: Map<string, string>): ProductListingQuery {
    const queryModel = new ProductListingQuery();

    queryModel.phrase = QueryParser.getValue(query, PHRASE, '');
    queryModel.sectors = QueryParser.getValues(query, SECTORS);
    queryModel.types = QueryParser.getValues(query, TYPES);
    queryModel.brands = QueryParser.getValues(query, BRANDS);
    queryModel.priceMin = parseInt(QueryParser.getValue(query, PRICE_MIN), 10);
    queryModel.priceMax = parseInt(QueryParser.getValue(query, PRICE_MAX), 10);
    queryModel.sort = QueryParser.getValue(query, SORT);
    queryModel.direction = QueryParser.getValue(query, DIRECTION);
    queryModel.expanded = QueryParser.getValues(query, EXPANDED);

    return queryModel;
  }

  public static toQuery(queryModel: ProductListingQuery): Map<string, string> {
    const query = new Map<string, string>();

    QueryParser.setValue(query, PHRASE, queryModel.phrase);
    QueryParser.setValues(query, SECTORS, queryModel.sectors);
    QueryParser.setValues(query, TYPES, queryModel.types);
    QueryParser.setValues(query, BRANDS, queryModel.brands);
    QueryParser.setValue(query, PRICE_MIN, queryModel.priceMin?.toString());
    QueryParser.setValue(query, PRICE_MAX, queryModel.priceMax?.toString());
    QueryParser.setValue(query, SORT, queryModel.sort);
    QueryParser.setValue(query, DIRECTION, queryModel.direction);
    QueryParser.setValues(query, EXPANDED, queryModel.expanded);

    return query;
  }
}
